var render = function render() {
  var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy;return _c('div', { staticClass: "credits-cost-tips" }, [_c('el-tooltip', { attrs: { "placement": "top", "disabled": _vm.disabled } }, [_c('div', { attrs: { "slot": "content" }, slot: "content" }, [_vm._t("tips", null, { "cost": _vm.result.cost, "balance": _vm.result.balance })], 2), _vm._v(" "), _c('span', [_vm._t("tips", null, { "cost": _vm.result.cost, "balance": _vm.result.balance })], 2)])], 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };